<template>
    <input
            type="file"
            :name="$parent.name"
            :id="$parent.inputId || $parent.name"
            :accept="$parent.accept"
            :capture="$parent.capture"
            @change="change"
            :webkitdirectory="$parent.directory && $parent.features.directory"
            :directory="$parent.directory && $parent.features.directory"
            :multiple="$parent.multiple && $parent.features.html5"
    />
</template>
<script>
	export default {
		name: 'inputFile',
		components: {},
		data() {
			return {}
		},
		methods: {
			change(e){
				this.$destroy()
				this.$parent.addInputFile(e.target)
				new this.constructor({
					parent: this.$parent,
					el: this.$el,
				})
            }
        },
		computed: {}
	}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/file-upload/InputFile.vue